
import { ArrowRight } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
import { Button } from "@/components/Button";
import { Link } from "react-router-dom";

const CtaSection = () => {
  return (
    <section className="py-20 bg-[#1A1F2C]">
      <div className="container mx-auto px-6">
        <AnimatedCard animation="fade-in" className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Let's Talk Strategy — <span className="text-primary">On Us</span>
          </h2>
          
          <p className="text-lg md:text-xl mb-10 mx-auto text-gray-300">
            We offer every firm a free, 60-minute advisory session to explore your AI goals, questions, 
            or ideas. Whether you're stuck, skeptical, or ready to go — we'll meet you where you are and 
            help you move forward.
          </p>
          
          <Link to="/services/strategy/free-discovery-session">
            <Button 
              variant="primary" 
              size="lg" 
              hasAnimation={true}
              className="text-base md:text-lg py-6 px-8"
            >
              Book Your Free Advisory Call
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <p className="mt-4 text-sm text-gray-400">No pressure. Just expert guidance from a team that gets it.</p>
        </AnimatedCard>
      </div>
    </section>
  );
};

export default CtaSection;
